import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        account_id: 0,
        type: '',
        request_method: '',
        request_url: '',
        error: '',
        status: '',
        headers: '',
        is_json: 0,
        timestamp: 0,
        body: '',
        request_body: '',
    },

    isError: function() {
        if (this.get('status') && this.get('status') >= 200 && this.get('status') <= 299) {
            return false;
        }
        return true;
    },

    getStatusText: function () {
        // no status means that the connection or request failed outside of the http context and the error parameter will be set
        return this.get('status') ? this.get('status') + (this.get('status') < 400 ? ' OK' : ' Error') : 'Error';
    },

    getIntegrationInfo: function () {
        const logos = {
            jira: { logo: '/image/jira_small.png', name: 'Jira' },
            slack: { logo: '/image/slack_small.png', name: 'Slack' },
            webhook: { logo: '/image/webhook_small.png', name: 'Webhook' },
            asana: { logo: '/image/asana_small.png', name: 'Asana' },
            clickup: { logo: '/image/clickup_small.png', name: 'ClickUp' },
            notion: { logo: '/image/notion_small.png', name: 'Notion' },
            linear: { logo: '/image/linear_small.png', name: 'Linear' },
            teamwork: { logo: '/image/teamwork_small.png', name: 'Teamwork' },
            trello: { logo: '/image/trello_small.png', name: 'Trello' },
            microsoft_teams: { logo: '/image/teams_small.png', name: 'Teams' },
            azure_devops: { logo: '/image/azure_devops_small.png', name: 'Azure' },
            zapier: { logo: '/image/zapier_small.png', name: 'Zapier' },
            github: { logo: '/image/github_small.png', name: 'Github' },
            gitlab: { logo: '/image/gitlab_small.png', name: 'Gitlab' },
            monday: { logo: '/image/monday_small.png', name: 'Monday' },
            basecamp: { logo: '/image/basecamp_small.png', name: 'Basecamp' },
            intercom: { logo: '/image/intercom_small.png', name: 'Intercom' },
            zendesk: { logo: '/image/zendesk_small.png', name: 'Zendesk' },
            wrike: { logo: '/image/wrike_small.png', name: 'Wrike' },
            email: { logo: '/image/email_forwarding_small.png', name: 'Email' },
        };

        return logos[this.get('type')];
    },
});
